import { track } from 'analytics/frontend';

const trackSelectedOption = (option: unknown) =>
  track('Selected option', {
    option,
    step: 'logged in UX',
  });

export default trackSelectedOption;
